import { Text, useBreakpointValue } from '@chakra-ui/react';

export const CardText = ({ fontSize, children }) => {
  const smallFontSize = useBreakpointValue({
    base: 'xs',
    xl: 'sm',
  });

  return (
    <Text as="strong" fontSize={fontSize || smallFontSize}>
      {children}
    </Text>
  );
};
